import React from 'react';
import { FiChevronUp } from 'react-icons/fi';
import { Badge } from '@/components/ui/badge';

function accuracyBadgeVariant(value) {
  if (value <= 33.33) return 'danger-soft';
  if (value <= 66.66) return 'amber-soft';
  return 'success-soft';
}

function accuracyBarColor(value) {
  if (value <= 33.33) return 'var(--color-danger)';
  if (value <= 66.66) return 'var(--color-mission)';
  return 'var(--color-success)';
}

function chartPerformanceCard({ playful = false, onClick, taxonomy, challenges }) {
  const lastResult = parseFloat(taxonomy?.last_result?.toFixed(1));
  let performanceClass = lastResult < 0 ? 'chart-performance__efficiency--down' : 'chart-performance__efficiency--up';
  if (lastResult === 0.0) {
    performanceClass = '';
  }

  if (playful && challenges) {
    const accuracy = taxonomy?.['question-accuracy'] ?? 0;

    return (
      <div className="flex items-center gap-4 rounded-[14px] border border-neutral-100 bg-white px-4 py-3 shadow-sm">
        <span
          className="min-w-0 flex-1 truncate text-sm font-bold text-neutral-700"
          title={taxonomy?.taxonomy}
        >
          {taxonomy?.taxonomy}
        </span>
        <span className="relative h-2 w-32 shrink-0 overflow-hidden rounded-full bg-neutral-100 sm:w-48">
          <span
            className="absolute inset-y-0 left-0 rounded-full"
            style={{ width: `${accuracy}%`, backgroundColor: accuracyBarColor(accuracy) }}
          />
        </span>
        <Badge
          variant={accuracyBadgeVariant(accuracy)}
          size="sm"
          className="w-16 shrink-0"
        >
          {accuracy}%
        </Badge>
      </div>
    );
  }

  return (
    <div
      className={`chart-performance ${taxonomy?.isActive ? 'active' : ''}`}
      onClick={onClick}
    >
      <span
        className="chart-performance__name"
        title={challenges ? taxonomy.taxonomy : taxonomy?.name}
      >
        {challenges ? taxonomy.taxonomy : taxonomy?.name}
      </span>
      <span className="chart-performance__bars">
        <span
          className="chart-performance__percentage-bar"
          style={{ width: `${challenges ? taxonomy['question-accuracy'] : taxonomy?.average_result}%` }}
        />
      </span>
      <span className="chart-performance__percentage-text">{challenges ? taxonomy['question-accuracy'] : taxonomy?.average_result?.toFixed(1)}%</span>
      <span className={`chart-performance__efficiency ${performanceClass}`}>
        {lastResult === 0.0 ? (
          `--`
        ) : (
          <>
            <FiChevronUp />
            {challenges ? taxonomy['question-accuracy'] : lastResult}%
          </>
        )}
      </span>
    </div>
  );
}

export default chartPerformanceCard;
